export default [
  'yolawebsitebuilder',
  'websitebuilderpro',
  'websitebuilderfree',
  'websitebuilderprod',
  'websitebuilderote',
  'websitebuilderpie',
  'cashflowdev_708',
  'cashflowforgedev',
  'cashflowtestoauth2',
  'cashflowlocaljohn',
  'cashflowforgedev_769',
  'cashflowforgedev_771',
  'cashflowforgedev_785',
  'cashflowforgeqa',
  'cashflowdev_803',
  'cashflowdev_804',
  'cashflowqa',
  'cashflowforgestage',
  'cashflowforgestage_812',
  'cashflowforgestage_813',
  'cashflowforgestage_814',
  'cashflowlocaljohn_820',
  'cashflowscaledev',
  'cashflowscaledev_824',
  'cashflowscalestage',
  'cashflowlocaltest',
  'cashflowscaledev_837',
  'cashflowforgestage_838',
  'cashflowauthtest',
  'cashflowauthtest_840',
  'cashflowauthtest_841',
  'cashflowscalestage_869',
  'cashflowfsso',
  'cashflowfsso_891',
  'cashflowfsso_892',
  'cashflow_907',
  'pickmycallfree',
  'cashflow_1008',
  'cashflow_1009',
];
